import React from "react";
import { Modal, Spinner } from "react-rainbow-components";
import ExchangeIcon from "./ExchangeIcon";
import { useUser } from "../../store/UserStore";
import {
  approveBooking,
  denyBooking,
  updateBooking,
} from "../../services/booking.service";
import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  Container,
  DropdownButton,
  ExchangeDataContainer,
  ModalContainer,
} from "./ChangeStatusComponent.style";
import { useError } from "../../store/ErrorModal";
import { GetErrorMessage } from "../../functions/error";

const ChangeStatusComponent = (props: {
  status: number;
  bookingId: string;
  uid: string;
  fetchData: () => void;
}) => {
  const [isOpenChange, setIsOpenChange] = React.useState<boolean>(false);
  const [status, setStatus] = React.useState<number>(props.status);
  const [value, SetValue] = React.useState<number>(props.status);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const userContext = useUser();
  const { onError } = useError();
  const statusLabel: string[] = [
    "ยังไม่ชำระเงิน",
    "ชำระเงินแล้ว",
    "กำลังให้บริการ",
    "สำเร็จ",
  ];

  const OnChangeModal = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setIsOpenChange(!isOpenChange);
    SetValue(parseInt(e.currentTarget.value));
  };

  const ConfirmModal = async () => {
    setIsLoading(true);
    try {
      await updateBooking(props.bookingId, {
        adminApproved: value !== 0 && `admin:${userContext.userData?.uid}`,
      });
      value !== 0
        ? await approveBooking(props.uid)
        : await updateBooking(props.bookingId, {
            adminApproved: null,
            refPayment: null,
          });
      value === 0 && (await denyBooking(props.uid));
      setStatus(value);
      setIsLoading(false);
      setIsOpenChange(!isOpenChange);
      props.fetchData();
    } catch (error: any) {
      onError(GetErrorMessage(error));
    }
  };
  const CloseModal = () => {
    SetValue(status);
    setIsOpenChange(!isOpenChange);
  };

  const RenderDropdown = statusLabel.map((label, index) => {
    return (
      index !== 2 &&
      index !== 3 && (
        <option key={index} value={statusLabel.indexOf(label)}>
          {label}
        </option>
      )
    );
  });

  return (
    <Container>
      <DropdownButton
        status={status}
        value={status}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => OnChangeModal(e)}
      >
        {value < 2 ? (
          RenderDropdown
        ) : value === 2 ? (
          <option value={statusLabel[status]}>{statusLabel[status]}</option>
        ) : (
          <option value="สำเร็จ">สำเร็จ</option>
        )}
      </DropdownButton>
      <Modal
        isOpen={isOpenChange}
        hideCloseButton
        onRequestClose={CloseModal}
        size="small"
      >
        <ModalContainer>
          {!isLoading ? (
            <React.Fragment>
              <h1>ยืนยันการเปลี่ยนแปลงสถานะ</h1>
              <ExchangeDataContainer>
                <div className="exchange">{statusLabel[status]}</div>
                <ExchangeIcon />
                <div className="exchange">{statusLabel[value]}</div>
              </ExchangeDataContainer>
              <ButtonContainer>
                <ConfirmButton onClick={ConfirmModal}>ยืนยัน</ConfirmButton>
                <CancelButton onClick={CloseModal}>ยกเลิก</CancelButton>
              </ButtonContainer>
            </React.Fragment>
          ) : (
            <Spinner />
          )}
        </ModalContainer>
      </Modal>
    </Container>
  );
};

export default ChangeStatusComponent;
